var QGIV = QGIV || {};

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
}

/*
 * Javascript Compatibility Checks
 */
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function(obj, start) {
         for (var i = (start || 0), j = this.length; i < j; i++) {
             if (this[i] === obj) { return i; }
         }
         return -1;
    }
}

if (typeof String.prototype.trim !== 'function') {
    String.prototype.trim = function() {
        return this.replace(/^\s+|\s+$/g, '');
    }
}


/*
 * The AJAX object for asynchronous, server interaction
 */
var ajaxHandler = {
    ajaxData : {
        url : '',
        type : 'POST',
        dataType : "JSON",
        csrf : true,
        csrf_token : $('#csrfToken').val(),
        postString : '',
        successCallback : function() {},
        failureCallback : function() {}
    },

    load : function() {
        var _this = this;

        if (_this.ajaxData.csrf) {
            if (typeof _this.ajaxData.postString == 'object') {
                _this.ajaxData.postString.csrfToken = _this.ajaxData.csrf_token;
            } else if (typeof _this.ajaxData.postString == 'string') {
                _this.ajaxData.postString += '&csrfToken=' + _this.ajaxData.csrf_token;
            }
        }

        jQuery.ajax({
            context: _this,
            url : _this.ajaxData.url,
            type : _this.ajaxData.type,
            data : _this.ajaxData.postString,
            dataType : _this.ajaxData.dataType,
            success : function(data) {
                if (_this.ajaxData.successCallback && (typeof(_this.ajaxData.successCallback) == "function")) {
                    _this.ajaxData.successCallback(data);
                }
            },
            error : function(data) {
                if (_this.ajaxData.failureCallback && (typeof(_this.ajaxData.failureCallback) == "function")) {
                    _this.ajaxData.failureCallback(data);
                }
            }
        });
    }
};

/*
 * Message object
 * Simple wrapper to post message
 */
var Message = {
    position : 'prependTo', // insertAfter, insertBefore, appendTo, prependTo
    type : 'success',
    message : '',
    msgClass : 'ui-message',
    target : '.page-content',
    scope : 'html, body',
    scrollToMessage : true,
    offset : 0,

    post : function(msg, type) {
        this.type = type;
        this.setMessage(msg);
        this.postMessage();
    },

    postMessage : function() {
        // remove previous message
        this.remove();

        // use the alert role by default for triggering screen readers
        let role = "alert";
        // use the status role for success as it's used to identify a status of success for an action
        if (this.type === "success") {
            role = "status";
        }

        const $html = $(
            `<div class="${this.msgClass} ${this.type}" role="${role}"></div>`,
        );
        $html.html(this.message);

        // insert message
        $html[this.position](this.target);

        // scroll to message
        if (this.scrollToMessage)
            UI.scrollToElement($html, 500, this.scope, this.offset);

        // reset message
        this.reset();
    },

    setMessage : function (msg, useRaw = false) {
        if (typeof msg == 'string') {
            this.message = useRaw ? msg : msg.replace(/(<([^>]+)>)/ig,"");
        } else if (typeof msg == 'object') {
            for (var index in msg) {
                if ( typeof msg[index] !== 'function' ){
                    this.message += useRaw ? msg[index] : msg[index].replace(/(<([^>]+)>)/ig,"") + "<br>";
                }
            }
        }
    },

    storeMessage : function(msg, id) {
        var id = id || 'broadcast_message';
        var msg = msg || {}; // { 'success' : 'Success message' }

        // turn object into a string
        msg = JSON.stringify(msg);

        // store the message in local storage
        WebStorage.set(id, msg);
    },

    postStoredMessage : function(id) {
        var id = id || 'broadcast_message';
        var storedMessage = WebStorage.get(id);

        if ( storedMessage ) {
            var msg = JSON.parse(storedMessage);
            var msgType = Object.keys(msg)[0];

            // post using postMessage
            this.post(msg[msgType], msgType);

            // clear the storage
            WebStorage.remove(id);
        }

    },

    remove : function() {
        if ($('.' + this.msgClass).length > 0) {
            $(this.target)
                .find('.' + this.msgClass)
                .not('.' + this.msgClass + '-permanent')
                .remove();
        }
    },

    reset : function() {
        this.type = 'success';
        this.position = 'prependTo';
        this.message = '';
        this.msgClass = 'ui-message';
        this.target = '.page-content';
    }
};

/*
 * PostMessage object
 * Simple Wrapper for Javascript postMessage
 */
var PostMessage = function(options){
    var _this = this;

    var defaults = {
        send : true,
        receive : true,
        onReceive : function(){},
        sendTarget : window.parent,
        targetOrigin : null // this should be the URL of the target window
    };

    _this.settings = $.extend({}, defaults, options);

    this.send = function(message, recipient){
        var message = message || '',
            recipient = recipient || _this.settings.targetOrigin,
            target = _this.settings.sendTarget;

        if ( !!window.postMessage ){
            target.postMessage(message, recipient);
        }
    };

    this.receive = function(event){
        if ( event.origin !== _this.settings.targetOrigin ) return;

        _this.settings.onReceive.call(undefined, event, event.data);
    };

    this.listen = function(){
        if ( window.addEventListener ){
            window.addEventListener('message', _this.receive, false);
        } else if ( document.attachEvent ) {
            window.attachEvent('onmessage', _this.receive);
        }
    };

    this.init = function(){
        if ( _this.settings.receive ){
            _this.listen();
        }

        if( _this.settings.targetOrigin === null ){
            if ( ! window.location.origin ){
                _this.settings.targetOrigin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
            } else {
                _this.settings.targetOrigin = window.location.origin;
            }
        }
    };

    _this.init();
};

/**
 * WebStorage Object
 * Simple wrapper for localStorage that allows use to check for support.
 */
var WebStorage = {
    supported : function(){
        var test = 'qfoobar';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch(e){
            return false;
        }
    },
    set : function(item, value){
        var item = item || '',
            value = value || '';

        if ( WebStorage.supported ){
            localStorage.setItem('q_' + item, value);
        }
    },
    get : function(item){
        var item = item || '';

        if ( WebStorage.supported ){
            return localStorage.getItem('q_' + item);
        }
    },
    remove : function(item){
        if ( item ) {
            localStorage.removeItem('q_' + item);
        }
    }
}


/*
 * Validation Object
 * Collection of validation functions.
 */
var Validation = {
    validateEmail : function(emailAddress) {
        var reEmail = /^[_A-z0-9-+']+(\.[_A-z0-9-+']+)*@[A-z0-9-]+(\.[A-z0-9-]+)*(\.[A-z]+)$/;
        emailAddress = emailAddress.replace(/\s/g,'');
        return reEmail.test(emailAddress.toLowerCase());
    },

    validateEmails : function(emailAddresses) {
            emailAddresses = emailAddresses.split(/,|;/g);
            var flag = true,
                _this = this;
            emailAddresses.forEach(function(email) {
                if (_this.validateEmail(email) === false) { flag = false }
            })
            return flag;
    },

    validatePhone : function (phone) {
        var phoneRegEx = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

        phone = (phone.replace(/\D/g,""));

        if (phoneRegEx.test(phone)) {
            return true;
        }

        return false;
    },

    validateZipCode : function (zip) {
        var zipRegEx = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
        zip = zip.replace(/\s/g,'');
        return zipRegEx.test(zip);
    },

    validateZipCodeConditional : function (zip) {
        // only validate zipCode if there is a value in the input
        if (!zip) {
            return true;
        }
        var zipRegEx = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
        zip = zip.replace(/\s/g,'');
        return zipRegEx.test(zip);
    },

    validateURL : function (url) {
        var urlRegEx = /(http|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;
        return urlRegEx.test(url);
    },

    validateBasicURL : function (url) {
        var urlRegEx = /[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;
        return urlRegEx.test(url);
    },

    validatePassword : function(password) {
        var groups = 0;

        if (password.length < 8) return false;

        if (/[A-Z]/.test(password)) groups++;
        if (/[a-z]/.test(password)) groups++;
        if (/[0-9]/.test(password)) groups++;
        if (/[!@#$%^&*()_\-=+{};:,<.?>]/.test(password)) groups++;

        if (groups >= 2) {
            return true;
        }

        return false;
    },

    /*
    * Validates a value to be a valid credit card number
    */
    validateCreditCard : function(card) {
        var card = card.replace(/[^0-9]/g,'');

        if ( card.length > 0 && QGIV.Payment.isValidCard(card) ) {
            return true;
        } else {
            return false;
        }
    },

    /*
    * Validates a month/year expiration pair to be greater than, or equal to, today's date
    */
    validateExpiration : function(month, year) {
        if (!this.validateCCYear(year) || !this.validateCCMonth(month)) {
            return false;
        }

        var d = new Date();
        var newYear = 2000 + parseInt(year, 10);

        if ((d.getFullYear() == newYear) && (d.getMonth()+1 > parseInt(month))) {
            return false;
        }

        return true;
    },

    /*
    * Validates credit card year, make sure it is greater or equal to this year
    */
    validateCCYear : function(year) {
        if (year == '') return false;

        var d = new Date();

        if (year.length == 2) {
            var newYear = 2000 + parseInt(year, 10);
        } else {
            var newYear = year;
        }

        if (d.getFullYear() > newYear) {
            return false;
        }

        return true;
    },

    /*
    * Validates credit card month, make sure it is between 1 - 12
    */
    validateCCMonth : function(month) {
        if (month == '') return false;

        var intMonth = parseInt(month);

        if (intMonth < 1 || intMonth > 12) {
            return false;
        }

        return true;
    },

    /*
    * Validates check number ensuring all characters are numeric
    */
    validateChkNumber : function(num) {
        var isNumeric = /^\d+$/;
        return isNumeric.test(num);
    },

    /*
    * Validates a value to be a valid routing number
    */
    validateRouting : function (aba) {
        var n = 0;
        var t = aba;

        if ( t.length !== 9 ) {
            return false;
        } else if ( /^\d{5}-\d{3}/.test(t) ) {
            return true;
        } else {
            for (i = 0; i < t.length; i += 3) {
                n += parseInt(t.charAt(i), 10) * 3 + parseInt(t.charAt(i + 1), 10) * 7 +  parseInt(t.charAt(i + 2), 10);
            }

            if ((n != 0) && ((n % 10) == 0)) {
                return true;
            }

            return false;
        }
    },

    /*
    * Validates a value to be a valid bank account number
    */
    validateAccount : function (account) {

        if (/^[0-9]{4,}$/.test(account.trim())) {
            return true;
        }

        return false;
    },

    /*
    * Validates a value to see if it's a valid Canadian Institution Number (3 digits)
    */
    validateCAInstNum : function (institution) {
        var t = institution;

        if ( t.length !== 3 ) {
            return false;
        } else if ( /\d{3}/.test(t) ) {
            return true;
        }

        return false;
    },

    /*
    * Validates a value to see if it's a valid Canadian Bank Transit Number (5 digits)
    */
    validateCABankTransitNum : function (transit) {
        var t = transit;

        if ( t.length !== 5 ) {
            return false;
        } else if ( /\d{5}/.test(t) ) {
            return true;
        }

        return false;
    },

    /*
    * Validates a value to see if it's a valid Canadian Bank Account Number (5-12 digits)
    */
    validateCABankAcctNum : function (account) {
        var t = account;

        if ( t.length < 5 || t.length > 12 ) {
            return false;
        } else if ((/[0-9]+$/.test(t))) {
            return true;
        }

        return false;
    },

    validateConfirmPassword : function(password, confirmedPassword) {
        if (password === confirmedPassword) {
            return true;
        }

        return false;
    },

    validateOneRequiredPhone: function (phone, cell) {
        if (phone.replace(/\W/g, '') == "" && cell.replace(/\W/g, '') == "") {
            return false;
        } else {
            return true;
        }
    },

    validateDate : function(inputDate){
        if (inputDate.replace(/ /g, '').length < 1) {
            return true;
        }

        var parts = inputDate.split('/');

        if (parts.length == 3) {
            var date = new Date(parts[2], parts[0] - 1, parts[1]),
                year = date.getFullYear().toString().substr(2,2);
                convertedDate = "" + year + ( date.getMonth() + 1 ) + date.getDate(),
                m = (  parts[0] < 10 ) ?  parts[0].toString().replace('0','') :  parts[0],
                d = ( parts[1] < 10 ) ? parts[1].toString().replace('0','') : parts[1],
                y = ( parts[2].length == 4 ) ? parts[2].substr(2,2) : parts[2],
                givenDate = "" + y + m + d;

                return (convertedDate == givenDate);
        }

        return false;
    },

    validateDateTimeFuture : function($target) {
        var current = new Date(),
            currentDay = current.getDate(),
            currentHour = current.getHours(),
            currentMinute = current.getMinutes(),
            $container = $target.closest('.js-datetime-container'),
            givenDate = $container.find('.js-datetime-date').val(),
            givenHour = $container.find('.js-datetime-hour'),
            givenHourValue = parseInt(givenHour.find('option:selected').val()),
            givenMinute = $container.find('.js-datetime-minute'),
            givenMinuteValue = parseInt(givenMinute.find('option:selected').val()),
            givenMeridiem = $container.find('.js-datetime-meridiem'),
            givenMeridiemValue = givenMeridiem.find('option:selected').val(),
            serverTimezoneDST = $container.attr('data-server-dst'),
            timeDifference = serverTimezoneDST == '1' ? 4 : 5,
            jsDate = new Date(givenDate),
            currentMDY = {
                month: current.getMonth(),
                day: currentDay,
                year: current.getFullYear()
            },
            jsMDY = {
                month: jsDate.getMonth(),
                day: jsDate.getDate(),
                year: jsDate.getFullYear()
            },
            mdy = Object.keys(currentMDY),
            // Flag that checks if current mdy matches js mdy values
            isToday = mdy.filter(function(key){
                return currentMDY[key] === jsMDY[key];
            }).length === mdy.length;

        // If there's a start datetime, compare against that instead of current datetime
        if ($container.find('.js-datetime-start').length) {
            current = new Date($container.find('.js-datetime-start').val());
            currentHour = parseInt($container.find('.js-datetime-start-hour option:selected').val());
            currentMinute = parseInt($container.find('.js-datetime-start-minute option:selected').val());
            var currentMeridiem = $container.find('.js-datetime-start-meridiem option:selected').val();

            if (currentMeridiem === 'PM') currentHour += 12;
            current.setHours(currentHour);
            current.setMinutes(currentMinute);
        }

        if (givenDate !== undefined && givenDate.length > 0) {
            // JS dates use 24 hours, so add 12 if after noon
            if (givenMeridiemValue === 'PM') givenHourValue += 12;

            // if its before noon, but noon was selected, flip the meridiem value
            if ( $target.is( givenHour ) || currentHour < 12 && givenMeridiemValue === 'AM' ) {
                if (givenHourValue === 12) givenMeridiem.find('option[value="PM"]').prop('selected', true);
            }

            // Apply the hours and minutes to jsDate
            jsDate.setHours(givenHourValue);
            jsDate.setMinutes(givenMinuteValue);

            // Convert the hours to UTC, so the local timezone doesn't affect things. Then, change it to EST
            // 1. Take the given timezone offset value, converted to hours, and add it to the given hour amount.
            // 2. Now that it is in GMT, either subtract 4 hours if the server's timezone has DST in effect, or 5 hours if not
            currentHour = currentHour + (current.getTimezoneOffset() / 60) - timeDifference;
            current.setHours(currentHour);

            // if current day and js day match, proceed with disabling logic
            if (isToday && !$container.find('.js-datetime-start').length) {
                givenHour.find( 'option' ).prop( 'disabled', false );

                // there are 4 situations to handle here
                // 1. after noon, selecting AM - disable all AM hours
                // 2. after noon, selecting PM - disable hours before the current hour
                // 3. before noon, selecting AM - disable hours before the current hour
                // 4. before noon, selecting PM - enable all hours
                if (currentHour >= 12) {
                    // 1. if it is after noon, disable AM and auto-select PM
                    givenMeridiem.find('option[value="AM"]').prop('disabled', true);
                    givenMeridiem.find('option[value="PM"]').prop('selected', true);

                    // 2. disable all hours before this one
                    for (var i = 1; i < parseInt(currentHour - 12); i++ ) {
                        givenHour.find('option:nth-child(' + i + ')').prop('disabled', true);
                    }
                    // including 12
                    givenHour.find('option[value="12"]').prop('disabled', true);
                } else {
                    // if it is before noon
                    if ( givenMeridiemValue === 'AM' ) {
                        // 3. if selecting AM hours, disable the hours before the current hour
                        for (var i = 1; i < currentHour; i++ ) {
                            givenHour.find('option:nth-child(' + i + ')').prop('disabled', true);
                        }
                    }
                    // 4. if selecting PM hours, nothing needs to be disabled
                }

                // disable the minutes before now if its this hour
                if (currentHour === jsDate.getHours()) {
                    // it is the current hour, then the :00 sharp is already passed
                    givenMinute.find('option[value="00"]').prop('disabled', true);
                    // on current hour, disable each minute value that has already passed
                    if (currentMinute > 15) givenMinute.find('option[value="15"]').prop('disabled', true);
                    if (currentMinute > 30) givenMinute.find('option[value="30"]').prop('disabled', true);
                    if (currentMinute > 45) givenMinute.find('option[value="45"]').prop('disabled', true);
                } else {
                    givenMinute.find('option').prop('disabled', false);
                }
            }
            else {
                givenHour.find('option').prop('disabled', false);
                givenMinute.find('option').prop('disabled', false);
                givenMeridiem.find('option').prop('disabled', false);
            } // end of current day check

            // now for some validation
            return (jsDate > current);
        } else { return false; }
    },

    validateDateDirectionForward : function(inputDate){
        var inputDate = new Date(inputDate),
            todaysDate = new Date();

        return (inputDate.setHours(0,0,0,0) >= todaysDate.setHours(0,0,0,0));
    },

    validateAlphaNumeric : function(value){
        if ( ((/[^a-zA-Z0-9\s]/g).test(value)) ) {
            return true;
        }

        return false;
    },

    validateMinAmount : function(value, minimum){
        if (!value.length || parseInt(value.replace(/,/g, '')) >= parseInt(minimum.replace(/,/g, ''))) {
            return true;
        }

        return false;
    },

    validateCommitmentAmount : function(value, commitmentAmount){
        if (!value.length || parseInt(value.replace(/,/g, '')) >= parseInt(commitmentAmount.replace(/,/g, ''))) {
            return true;
        }

        return false;
    },

    validateMaxAmount : function(value, maximum){
        if ( ! value.length || parseFloat( value.replace( /,/g, '' ) ) <= parseFloat( maximum.replace( /,/g, '' ) ) ) {
            return true;
        }

        return false;
    },

    validateMinChar: function (value, minimum) {
        if (value.length >= parseFloat(minimum)) {
            return true;
        }

        return false;
    },

    validateMaxChar: function (value, maximum) {
        if (value.length <= parseFloat(maximum)) {
            return true;
        }

        return false;
    },

    validateIsMultiCheckboxGroupChecked: (element) => {
        const checkedInputs = element.find("input:checked");
        return checkedInputs.length && checkedInputs[0].type === "checkbox";
    },

    validateIsRadioGroupChecked: (element) => {
        const radioGroupName = element.attr("name");
        const checkedRadioButtonsSelector = `input[name="${radioGroupName}"]:checked`;
        const isRadioGroupChecked = $(checkedRadioButtonsSelector).length > 0;
        return isRadioGroupChecked;
    },

    validateIsChecked: (element) => {
        if (element.type !== "checkbox") return false;
        return element.checked;
    },

    validateBadWordsAsync: (text) => new Promise((resolve) => {
        $.fn.qpost({
            url : '/api/v1/badwords/check',
            method: 'post',
            data : { text, system: 1},
            success : (data)=> {
                const { badwords, message } = data.response;
                const isValid = badwords.all.length === 0;

                resolve({ isValid, message, badwords });
            }
        });
    }),

    showInlineLoading : function(selector){
        $(selector).closest('.has-inline-validation').addClass('validation-loading');
    },

    showInlineValidationSuccess : function(selector){
        $(selector).closest('.has-inline-validation')
            .removeClass('validation-loading validation-error')
            .addClass('validation-success');
    },

    showInlineValidationError : function(selector){
        $(selector).closest('.has-inline-validation')
            .removeClass('validation-loading validation-success')
            .addClass('validation-error');
    },

    clearInlineLoading : function(selector){
        $(selector).closest('.has-inline-validation')
            .removeClass('validation-loading validation-error validation-success');
    },
};

/**
 * Form Validation jQuery Plugin
 **/
var FormValidation = function(element, options){
    this.settings = $.extend({}, this.defaults, options);
    this.bind(element);
    this.addError = this.addError.bind( this );
    this.removeError = this.removeError.bind( this );
};

FormValidation.prototype = {

    // shorthand for using prototype
    constructor : FormValidation,

    // default options
    defaults : {
        fieldWrapper     : '.field-container',
        errorClass       : 'field-message',
        submitValidation : '.trigger-submit-validation',
        validationClass : {
            email              : '.validateEmail',
            emails             : '.validateEmails',
            url                : '.validateURL',
            basicURL           : '.validateBasicURL',
            empty              : '.validateEmpty',
            emptySelect        : '.validateSelectEmpty',
            emptyRadio         : '.validateRadioEmpty',
            emptyFuzzySearch   : '.validateFuzzySearchEmpty',
            emptyMultiCheckbox : '.validateMultiCheckboxEmpty',
            chosen             : '.chosen-container',
            zip                : '.validateZipCode',
            zipConditional     : '.validateZipCodeConditional',
            phone              : '.validatePhone',
            emptyPhone         : '.validateEmptyPhone',
            chkNumber          : '.validateChkNumber',
            creditCard         : '.validateCreditCard',
            ccMonth            : '.validateCCMonth',
            ccYear             : '.validateCCYear',
            routing            : '.validateRouting',
            caInstNum          : '.validateCAInstNum',
            caBankTransNum     : '.validateCABankTransitNum',
            caBankAcctNum      : '.validateCABankAcctNum',
            account            : '.validateAccount',
            password           : '.validatePassword',
            passwordConfirm    : '.validatePasswordConfirm',
            date               : '.validateDate',
            dateForward        : '.validateDateDirectionForward',
            dateTimeFuture     : '.validateDateTimeFuture',
            dateTimeRange      : '.validateDateTimeRange',
            homePhone          : '.validateHomePhone',
            cell               : '.validateCell',
            requireOnePhone    : '.requireOnePhone',
            alphaNumericOnly   : '.validateAlphaNumeric',
            minimumAmount      : '.validateMinAmount',
            commitmentAmount   : '.validateCommitmentAmount',
            maximumAmount      : '.validateMaxAmount',
            amountRange        : '.validateAmountRange',
            minimumChar        : '.validateMinChar',
            maximumChar        : '.validateMaxChar',
            requiredMaximumChar: '.validateRequiredMaxChar',
            uniqueTeamName     : '.validateUniqueTeamName',
            requiredTag        : '.validateRequiredTag',
            requiredCheck      : ".validateRequiredCheck",
            matchCheck         : ".validateMatchCheck",
            badWordsCheck      : ".validateAcceptableWords",
            badWordsWarning    : ".wanringAcceptableWords",
        },
        onError         : function(){},
        onSuccess       : function(){}
    },

    element: null,
    $form: null,

    bind : function(element){
        var _this = this;
        var s = element;

        _this.element = element;
        _this.$form = $(s);

         $(s).on('blur', _this.settings.validationClass.empty, function(e){
            if ($(this).val().trim().length < 1) {
                _this.addError($(this), _this.getFieldName($(this)) + " cannot be empty");
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur change', _this.settings.validationClass.emptySelect, function(e){
            // NOTE: do not use trim here as multiple selects return an array
            if (!$(this).val()?.length || $(this).val() == 'Please Select One') {
                _this.addError($(this), "Please select" + ((QGIV.Utilities.startsWithVowel(_this.getFieldName($(this)))) ? " an " : " a ") + _this.getFieldName($(this)) );
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur change', _this.settings.validationClass.emptyRadio, function(e){
           if ( ! $('[name="' + $(this).attr('name') + '"]:checked').length ) {
               _this.addError($(this), "Please select" + ((QGIV.Utilities.startsWithVowel(_this.getFieldName($(this)))) ? " an " : " a ") +  _this.getFieldName($(this)) );
           } else {
               _this.removeError($(this));
           }
       });

        $( s ).on( 'blur change', _this.settings.validationClass.emptyFuzzySearch, function() {
            if ( $( this ).val().trim().length < 1 ) {
                _this.addError( $( this ), 'Please select' + ( ( QGIV.Utilities.startsWithVowel( _this.getFieldName( $( this ) ) ) ) ? ' an ' : ' a ') +  _this.getFieldName( $( this ) ) );
            } else {
                _this.removeError( $( this ) );
            }
        });

        $(s).on( 'blur change', _this.settings.validationClass.emptyMultiCheckbox, function(e){
            if ( $(this).find( 'input[type="checkbox"]:checked' ).length < 1 ) {
                _this.addError( $(this), "Please select" + ((QGIV.Utilities.startsWithVowel(_this.getFieldName($(this)))) ? " an " : " a ") +  _this.getFieldName($(this)) );
            } else {
                _this.removeError( $(this) );
            }
        });

        $(s).on('blur', _this.settings.validationClass.chosen, function(e) {
            var $select = $(this).siblings('.chosen-select');

            if ($select.hasClass('validateSelectEmpty')) {
                $select.trigger('blur');
            }
        });

        $(s).on('blur', _this.settings.validationClass.requiredTag, function(e) {
            var tag = $(this).attr('data-requiredTag');
            var val = $(this).val();

            if (!tag) {
                return _this.removeError($(this));
            }

            var tags = tag.split(";@;");
            var missingTags = []

            tags.forEach(function(tag) {
                if (val.indexOf(tag) === -1) {
                    missingTags.push(tag)
                }
            })

            if (missingTags.length > 0) {
                var errorStr = _this.getFieldName($(this)) + " is missing required tag ";
                missingTags.forEach(function(tag, i) {
                    errorStr += i > 0 ? ", " + tag : tag
                })
                _this.addError($(this), errorStr);
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.email, function(e){
            //only validate email empty if the empty class is present
            if (($(this).val().trim() == '' && $(this).hasClass(_this.settings.validationClass.empty.replace('.', ''))) || ($(this).val().trim() != '')) {
                if (!Validation.validateEmail($(this).val())) {
                    _this.addError($(this), "Invalid " + _this.getFieldName($(this)) );
                } else {
                    _this.removeError($(this));
                }
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.emails, function(e){
            //only validate emails empty if the empty class is present
            if (($(this).val().trim() == '' && $(this).hasClass(_this.settings.validationClass.empty.replace('.', ''))) || ($(this).val().trim() != '')) {
                if (!Validation.validateEmails($(this).val())) {
                    _this.addError($(this), "Invalid " + _this.getFieldName($(this)) );
                } else {
                    _this.removeError($(this));
                }
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.url, function(e){
            if (!Validation.validateURL($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)) );
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.basicURL, function(e){
            if (!Validation.validateBasicURL($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)) );
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.zip, function(e){
            if (!Validation.validateZipCode($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)));
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.zipConditional, function(e){
            if (!Validation.validateZipCodeConditional($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)));
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.phone, function(e){
            if ($(this).val().length > 0) {
                if (!Validation.validatePhone($(this).val()) && $(this).val().length > 0) {
                    _this.addError($(this), "Invalid " + _this.getFieldName($(this)));
                } else {
                    _this.removeError($(this));
                }
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.emptyPhone, function (e) {
            if ($(this).val().length === 0) {
                _this.addError($(this), `${_this.getFieldName($(this))} cannot be empty`);
            } else {
                if (!Validation.validatePhone($(this).val())) {
                    _this.addError($(this), "Invalid phone number.");
                } else {
                    _this.removeError($(this));
                }
            }
        });

        $(s).on('blur', _this.settings.validationClass.creditCard, function(e){
            $(this).val($(this).val().replace(/[^0-9]/g, ''));

            if (!Validation.validateCreditCard($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)));
            } else {
                _this.removeError($(this));
            }
        });

        // prevent invalid input
        $($).on('input', _this.settings.validationClass.ccMonth, function(e) {
            _this.maskCCFieldValue(e.target)
        })

        $(s).on('blur', _this.settings.validationClass.ccMonth, function(e){
            if (!Validation.validateCCMonth($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)));
            } else {
                _this.removeError($(this));
            }
        });

        // prevent invalid input
        $($).on('input', _this.settings.validationClass.ccYear, function(e) {
            _this.maskCCFieldValue(e.target)
        })

        $(s).on('blur', _this.settings.validationClass.ccYear, function(e){
            if (!Validation.validateCCYear($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)));
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.routing, function(e){
            if (!Validation.validateRouting($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)));
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.account, function(e){
            if (!Validation.validateAccount($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)));
            } else {
                _this.removeError($(this));
            }
        });

         //check number
         $(s).on('blur', _this.settings.validationClass.chkNumber, function(e){
            if (!Validation.validateChkNumber($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)));
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.caInstNum, function(e){
            if (!Validation.validateCAInstNum($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)) + ". Must be only numbers and 3 digits long.");
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.caBankTransNum, function(e){
            if (!Validation.validateCABankTransitNum($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)) + ". Must be only numbers and 5 digits long.");
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.caBankAcctNum, function(e){
            if (!Validation.validateCABankAcctNum($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)) + ". Must be only numbers and 5-12 digits long.");
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.password, function(e){
            if (!Validation.validatePassword($(this).val())) {
                _this.addError($(this), "A valid password must have a minimum of 8 characters and contain at least two of the following: Special characters, upper case characters, lower case characters, and numbers.");
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.passwordConfirm, function(e){
            var pass = $(s).find(_this.settings.validationClass.password).val();
            var pass2 = $(this).val();

            if (!Validation.validateConfirmPassword(pass, pass2)) {
                _this.addError($(this), "Your password and password confirmation do not match.");
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur change', _this.settings.validationClass.date, function(e){
            $(this).val($(this).val().replace('-', '/'));

            if (!Validation.validateDate($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)) );
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur change', _this.settings.validationClass.dateTimeFuture, function(e){
            if (!Validation.validateDateTimeFuture($(this))) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)) + ". Date and time must be today or later." );
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur change', _this.settings.validationClass.dateTimeRange, function(e){
            if (!Validation.validateDateTimeFuture($(this))) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)) + ". Start Date and time must be earlier than End Date and time." );
            } else {
                _this.removeError($(this));
                // if start date, or other date fields are present, remove any lingering error styles
                if ($(this).closest('.js-datetime-container').find('.js-datetime-date')) {
                    _this.removeError($(this).closest('.js-datetime-container').find('.js-datetime-date'));
                }
                if ($(this).closest('.js-datetime-container').find('.js-datetime-start')) {
                    _this.removeError($(this).closest('.js-datetime-container').find('.js-datetime-start'));
                }
            }
        });

        $(s).on('blur', _this.settings.validationClass.dateForward, function(e){
            if (!Validation.validateDateDirectionForward($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)) + ". Date must be today or later." );
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.requireOnePhone, function(e){
            var phone = $(s).find(_this.settings.validationClass.homePhone).val();
            var cell = $(s).find(_this.settings.validationClass.cell).val();
            if (!Validation.validateOneRequiredPhone(phone, cell)) {
                _this.addError($(this), "At least one phone is required.");
            } else if ($(this).val().replace(/\W/g, '') != "" && !Validation.validatePhone($(this).val())) {
                _this.addError($(this), "Invalid " + _this.getFieldName($(this)));
            } else {
                //remove the errors from both the inputs if it gets here
                _this.removeError($(_this.settings.validationClass.homePhone));
                _this.removeError($(_this.settings.validationClass.cell));
            }
        });

        $(s).on('blur', _this.settings.validationClass.p2pUsername, function(e){
            var formId = $('input[name="form"]').val();
            var element = $(this);
            var isSub = $(s).find(_this.settings.validationClass.p2pUsername).attr('data-field-type');

            if (element.val().trim() != '' && Validation.validateEmail(element.val())) {
                Validation.showInlineLoading(element);
                Validation.validateHobnobUniqueUsername(formId, $(this).val(), isSub, function(validated) {
                    if (validated == true) {
                        Validation.showInlineValidationSuccess(element);
                        _this.removeError(element);
                    } else {
                        Validation.showInlineValidationError(element);
                        _this.addError(element, 'The username you entered is already registered for this campaign. If this is you, <a class="link-bold" href="'+url('hobnob_login', [$('input[name="form"]').val()])+'">login now</a>.');
                    }
                });
            }
        });

        $(s).on('blur', _this.settings.validationClass.alphaNumericOnly, function(e){
            if (Validation.validateAlphaNumeric($(this).val())) {
                _this.addError($(this), "This field must only contain letters and numbers.");
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on('blur', _this.settings.validationClass.minimumAmount, function(e){
            if (!Validation.validateMinAmount($(this).val(), $(this).attr('data-min-amount'))) {
                _this.addError($(this), "Amount is less than the minimum of " + formatFormCurrency($(this).attr('data-min-amount')) + ".");
            } else {
                _this.removeError($(this));
            }
        });


        $(s).on('blur', _this.settings.validationClass.maximumAmount, function(e){
            if ( ! $( this ).hasClass( _this.settings.validationClass.empty.replace( '.', '' ) ) || $( this ).val().trim().length > 0 ) {
                if ( $( this ).val() == 0 ) {
                    _this.addError( $( this ), 'Matching Donation Amount must be greater than $0.00.' );
                } else if ( $( this ).attr( 'data-max-amount' ) === 'undefined' || $( this ).attr( 'data-max-amount' ) <= 0 ) {
                    _this.addError( $( this ), 'Input a donation amount above before adding a matching donation.' );
                } else if ( ! Validation.validateMaxAmount( $( this ).val(), $( this ).attr( 'data-max-amount' ) ) ) {
                    _this.addError( $( this ), 'Amount is more than the maximum of ' + formatFormCurrency( $( this ).attr( 'data-max-amount' ).replace( /,/g, '' ) ) + '.' );
                } else {
                    _this.removeError( $( this ) );
                }
            }
        });

        $(s).on('blur', _this.settings.validationClass.commitmentAmount, function(e){
            if (!Validation.validateCommitmentAmount($(this).val(), $(this).attr('data-commitment-amount'))) {
                _this.addError($(this), "Amount is less than the minimum of " + formatFormCurrency($(this).attr('data-commitment-amount')) + ".");
            } else {
                _this.removeError($(this));
            }
        });

        $(s).on("blur", _this.settings.validationClass.amountRange, (e) => {
            const $input = $(e.target);
            const value = $input.val();
            const label = _this.getFieldName($input);
            if (!value.trim().length) {
                if (!$input.hasClass("validateEmpty")) _this.removeError($input);
                return;
            }

            const minimum = $input.attr("data-min-amount");
            const maximum = $input.attr("data-max-amount");
            const isValidMin = Validation.validateMinAmount(value, minimum);
            const isValidMax = Validation.validateMaxAmount(value, maximum);
            if (isValidMin && isValidMax) {
                return _this.removeError($input);
            }
            _this.addError(
                $input,
                `${label} must be between ${formatFormCurrency(minimum)} and ${formatFormCurrency(maximum)}`
            );
        });

        $(s).on('focus keyup', _this.settings.validationClass.minimumChar, function (e) {
            var $this = $(this);
            var value = $this.val();
            var minimum = $this.attr('data-minimum-characters') ? $this.attr('data-minimum-characters') : '50';
            if (!Validation.validateMinChar(value, minimum)) {
                _this.addError($this, 'Character input for ' + _this.getFieldName($this) + ' must be greater than ' + minimum + '. Current count is: ' + value.length + '.');
            } else {
                _this.removeError($this);
            }
        });

        $(s).on('focus keyup', _this.settings.validationClass.maximumChar, function (e) {
            var $this = $(this);
            var value = $this.val();
            var maximum = $this.attr('data-maximum-characters') ? $this.attr('data-maximum-characters') : '150';
            if (!Validation.validateMaxChar(value, maximum)) {
                _this.addError($this, `${_this.getFieldName($this)} must be fewer than ${maximum} characters. Current count is: ${value.length}.`);
            } else {
                _this.removeError($this);
            }
        });

        $(s).on('focus keyup blur', _this.settings.validationClass.requiredMaximumChar, function (e) {
            var $input = $(e.target);
            var value = $input.val();
            var maximum = $input.attr('data-maximum-characters') ? $input.attr('data-maximum-characters') : '150';
            const fieldName = _this.getFieldName($input);
            if (!value?.length) {
                _this.addError($input, `${fieldName} cannot be empty`);
                return;
            }
            if (!Validation.validateMaxChar(value, maximum)) {
                _this.addError($input, `${fieldName} must be fewer than ${maximum} characters. Current count is: ${value.length}.`);
                return;
            }
            _this.removeError($input);
        });

        $( s ).on( 'blur', _this.settings.validationClass.uniqueTeamName, function( e ) {
            var $el = $( this );
            var name = $el.val();
            var data = '';
            var formId;

            // Form id exists in global qgiv object on form pages.
            // In VT, form id is found in the selected form input.
            formId = QGIV.Form != undefined ? QGIV.Form.id : $( '#vt-forms' ).val();
            data += 'type=teamName' + '&teamName=' + encodeURIComponent( name );

            $.fn.qpost({
                url : url('p2p_validation', [ formId ]),
                data : data,
                success : function( response ){
                    if ( response.success === true ) {
                        _this.removeError( $el );
                    } else {
                        _this.addError( $el, 'That team name is taken. Please create a new name.' );
                    }
                }
            });
        });

        $(s).on("blur", _this.settings.validationClass.requiredCheck, (e) => {
            const input = e.target;
            const $input = $(input);
            const isValid = Validation.validateIsChecked(input);
            if (!isValid) {
                _this.addError(
                    $input,
                    `${_this.getFieldName($input)} is required`,
                );
                return;
            }
            _this.removeError($input);
        });

        $(s).on("keyup", _this.settings.validationClass.matchCheck, (e) => {
            const input = e.target;
            const $input = $(input);
            const match = $input.data("match");
            const enable = $input.data("enable");
            const isValid = $input.val() == match;

            if (enable) {
                $(enable).toggleClass('is-disabled', !isValid);
            }

            if (!isValid) {
                _this.addError(
                    $input,
                    `${_this.getFieldName($input)} does not match "${match}"`,
                );
                return;
            }
            _this.removeError($input);
        });

        $(s).on("blur", _this.settings.validationClass.badWordsCheck, async ({ target }) => {
            const {
                removeError, addError,
                settings: {
                    validationClass: {
                        requiredCheck,
                        requiredMaximumChar,
                        empty,
                    },
                },
             } = _this;
            const { value } = target;
            const $input = $(target);

            if(!value) {
                if(
                    !$input.is(requiredCheck) &&
                    !$input.is(requiredMaximumChar) &&
                    !$input.is(empty)
                ) {
                    removeError($input);
                }

                Validation.clearInlineLoading($input);
                return;
            }

            Validation.showInlineLoading($input);

            const { isValid, badwords } = await Validation.validateBadWordsAsync(value);

            Validation.clearInlineLoading($input);

            if (isValid) {
                if (
                    !$input.is(requiredMaximumChar) ||
                    Validation.validateMaxChar(value, $input.attr('data-maximum-characters'))
                ) {
                    removeError($input);
                }
                return;
            }

            addError(
                $input,
                `<i class="far fa-exclamation-circle"></i>${" "}${badwords.all.join(", ")} goes against our safety guidelines. Try using a different word or <a href="https://support.qgiv.com/hc/en-us/articles/22810963051799">learn more here</a>.`,
            );
        });

        $(s).on("blur", _this.settings.validationClass.badWordsWarning, async ({ target }) => {
            const {
                removeError, addError,
                settings: {
                    validationClass: {
                        requiredCheck,
                        requiredMaximumChar,
                        empty,
                    },
                },
             } = _this;
            const { value } = target;
            const $input = $(target);

            if(!value) {
                if(
                    !$input.is(requiredCheck) &&
                    !$input.is(requiredMaximumChar) &&
                    !$input.is(empty)
                ) {
                    removeError($input);
                }

                Validation.clearInlineLoading($input);
                return;
            }

            Validation.showInlineLoading($input);

            const { isValid, message } = await Validation.validateBadWordsAsync(value);

            Validation.clearInlineLoading($input);

            if (isValid) {
                if (
                    !$input.is(requiredMaximumChar) ||
                    Validation.validateMaxChar(value, $input.attr('data-maximum-characters'))
                ) {
                    removeError($input);
                }
                return;
            }

            addError(
                $input,
                `<i class="far fa-exclamation-circle"></i>${" "}${message}`,
                true,
            );
        });

        // trigger submit validation
        $(s).on('click', _this.settings.submitValidation, function(){
            var validations = _this.settings.validationClass;

            // loop through all validations
            for ( var prop in validations ){
                if ( $(s).find(validations[prop]).length > 0 ){
                    $(s).find(validations[prop]).trigger('blur');
                }
            }
        });
    },

    getFieldName : function(element){
        return element.attr('data-field');
    },

    addError : function(input, msg, isWarning) {
        var _this = this;
        var position = 'append',
            container = _this.settings.fieldWrapper,
            messageText = '';
        let errorClass = _this.settings.errorClass;

        // remove error label and class
        _this.removeError(input);

        // the input has an attribute that should prefix the error message
        if ( typeof input.attr('data-field-prefix') !== 'undefined' ) {
            messageText += input.attr('data-field-prefix');
        }

        // the input has a class than should be added to the error message
        if ( typeof input.attr('data-error-class') !== 'undefined' ) {
            errorClass += input.attr('data-error-class');
        }

        messageText += msg;


        let helpTextEl = input.closest(container).find('.custom-field-help-text')[0],
            helpTextHeight = 0,
            inlineStylingToAccommodateHelpText = ' ';

        // if there's a helpText for the field, grab the help element and store its height.
        // use that height to assign padding-top and transformY to the errorMessage element
        // this way helpText and errorMessage can be displayed simultaneously without overlap (in p2p donation forms)
        if (helpTextEl) {
            let marginOffset = 18;
            helpTextHeight = parseInt(helpTextEl.getBoundingClientRect().height + marginOffset);
            inlineStylingToAccommodateHelpText = `padding-top:${helpTextHeight}px; transform: translateY(-${helpTextHeight}px);`;
        }

        var message = $(`<span class="${errorClass}" role="alert" aria-live="assertive" style="${inlineStylingToAccommodateHelpText}">${messageText}</span>`);

        if (input.attr('data-onerror')) {
            var target = input.attr('data-onerror');
            message.attr('data-input', input.attr('id'));
            $(target)[position](message);
        } else {
            input.closest(container)[position](message);
        }

        if (isWarning) return;

        input.addClass('has-error');
    },

    removeError : function(input) {
        var _this = this;
        var position = 'find',
            container = _this.settings.fieldWrapper,
            inputID = input.attr('id');

        if (input.attr('data-onerror')) {
            container = $(input.attr('data-onerror'));
            container[position]('.' + _this.settings.errorClass + '[data-input=' + inputID + ']').remove();
        } else if (input.closest(container)[position]('.' + _this.settings.errorClass).length > 0) {
            input.closest(container)[position]('.' + _this.settings.errorClass).remove();
        }

        if (input.hasClass('has-error')) {
            input.removeClass('has-error');
        }
    },

    validateForm : function(includeHidden, exclude) {
        var _this = this,
            errors = [],
            includeHidden = includeHidden || false,
            exclude = exclude || false,
            validations = _this.settings.validationClass;

        // loop through all validations
        for ( var prop in validations ){
            if ( _this.$form.find(validations[prop]).length ){
                var $fields = _this.$form.find(validations[prop]);

                if ( ! includeHidden ) {
                    $fields = $fields.filter(':visible');
                }

                $fields.each(function(){
                    // check if this fieldshould be excluded from validation and skip it
                    if ( exclude && exclude.index($(this)) > -1 ) return;

                    // trigger validation
                    $(this).trigger('blur');

                    // get the error from our field container
                    var error = $(this).closest(_this.settings.fieldWrapper).find('.' + _this.settings.errorClass).text();

                    // if we have an error message that hasn't already been added, add it to the array
                    if ( error.length && $.inArray(error, errors) < 0 ) {
                        errors.push(error);
                    }
                });
            }
        }

        // return array of errors
        return errors;
    },

    maskCCFieldValue: function (input) {
        const { value } = input;

        const result = () => {
            if (parseInt(value) > 99) return value.slice(0,2);
            else if (parseInt(value) > 0 && parseInt(value) < 10) return ('0' + parseInt(value));
            else if (parseInt(value) === 0) return '00';
            else return String(parseInt(value));
        }

        input.value = result();
    },

    destroy: function() {
        var _this = this;

        _this.$form.off().removeData('qg_validation');
        _this.$form = null;
        _this.element = null;

    }
};

$.fn.validate = function ( options ) {
    return this.each(function () {
        if (!$.data(this, 'qg_validation')) {
            $.data(this, 'qg_validation',
            new FormValidation( this, options ));
        }
    });
};

/*
 * Notification object
 */
var NotificationHandler = {
    init : function() {
        var _this = this;

        // bind click message content, redirect user to the message center
        $('.notifications-modal-container .news-message').on('click', function(){
            var messageId = $(this).data('data-message-id');

            window.location.href = '/control/messages/?id=' + messageId;
        });

        // bind click message
        $('.notifications-modal-container .close-modal').on('click', function() {
            var messageIds = '';

            $('.news-messages li').each(function() {
                messageIds += $(this).attr('data-message-id') + ',';
            });

            messageIds = messageIds.slice(0, -1);

            var data = 'dismiss=1&ids='+encodeURIComponent(messageIds);

            var success = function(data) {
                if (data == "success") {
                    $('.notifications-modal-container').slideUp();
                    $('.notifications-modal-container').removeClass('show-modal').removeClass('show-new-messages');
                }
            };

            _this.call(data, 'html', success);
        });
    },

    // ajax call for notification
    call : function(data, dataType, successCallback) {
        $.fn.qpost({
            url : url('messages'),
            dataType : dataType,
            data : data,
            success : successCallback
        });
    }
}

/*
 * val_or_empty : uses to retrieve value, avoiding getting 'undefined' value
 */
$.fn.val_or_empty = function(){
    return ($(this).val() ? $(this).val() : '');
}

/*
 * capitalize : uses to retrieve value with first char as upper case
 */
$.fn.capitalize = function() {
    if ($(this).val().length > 0) {
        var pieces = $(this).val().split(" ");

        for ( var i = 0; i < pieces.length; i++ ) {
            var j = pieces[i].charAt(0).toUpperCase();
            pieces[i] = j + pieces[i].substr(1);
        }

        return pieces.join(" ");
    } else {
        return '';
    }
}

/*
 * qpost : uses to perform ajax call within Qgiv platform
 */
$.fn.qpost = function( options ) {
    var defaults = {
        url : window.location.href,
        type : 'POST',
        dataType : 'JSON',
        addCsrfToUrl: false,
        csrf : true,
        csrf_token : '',
        data : '',
        success : function() {},
        failure : function() {}
    };

    var settings = $.extend({}, defaults, options);

    function init() {
        var csrfToken = $('#csrfToken').val_or_empty();

        if (settings.csrf) {
            if (settings.csrf_token == '') {
                settings.csrf_token = csrfToken;
            }

            if (typeof settings.data == 'object') {
                settings.data.csrfToken = settings.csrf_token;
            } else if (typeof settings.data == 'string') {
                settings.data += '&csrfToken=' + settings.csrf_token;
            }
        }

        if (settings.addCsrfToUrl) {
            // check if there are already query params in the url
            if (settings.url.includes('?')) {
                settings.url += `&csrfToken=${csrfToken}`
            } else {
                settings.url += `?csrfToken=${csrfToken}`
            }
        }

        return $.ajax({
            url : settings.url,
            type : settings.type,
            data : settings.data,
            dataType : settings.dataType,
            success : function(data) {
                if (settings.success && (typeof(settings.success) == "function")) {
                    settings.success(data);
                }
            },
            error : function(data) {
                if (settings.failure && (typeof(settings.failure) == "function")) {
                    settings.failure(data);
                }
            }
        });
    }

    return init();
}

/*
 * fsearch : plugin uses to perform search
 */
$.fn.fsearch = function ( options ) {
    var _this = this;

    var defaults = {
        length          : 2,
        list            : '.search-list',
        target          : 'data-content',
        reset           : false,
        keyupCallback   : function() {},
        resetCallback   : function() {},
        searchCallback  : function(count) {},
        onBeforeSearch  : function(){},
        onAfterSearch  : function($list){},
        onReset  : function(){}
    };

    _this.settings = $.extend(defaults, options);

    if(typeof String.prototype.trim !== 'function') {
        String.prototype.trim = function() {
            return this.replace(/^\s+|\s+$/g, '');
        }
    }

    function search(key) {
        var count = 0,
            regexp = '',
            words = key.trim().split(/\s+/g);

        regexp = '(?=.*' + words.join(")(?=.*") + ')+';

        _this.settings.onBeforeSearch.call(_this);

        $(_this.settings.list).each(function() {
            if ($(this).attr(_this.settings.target).length === undefined) {
                $(this).hide();
            } else if ($(this).attr(_this.settings.target).search(new RegExp(regexp, 'i')) < 0) {
                $(this).hide();
            } else {
                $(this).show();
                count++;
            }
        });

        _this.settings.onAfterSearch.call(_this, $(_this.settings.list));

        if (typeof _this.settings.searchCallback == 'function') _this.settings.searchCallback(count);
    }

    function displayAll() {
        $(_this.settings.list).each(function(e) {
            $(this).show();
        });
    }

    function reset() {
        if (typeof _this.settings.resetCallback == 'function') _this.settings.resetCallback();

        displayAll();
        _this.settings.onReset.call(_this);
        $(this).val('');
    }

    if (_this.settings.reset) {
        $(this).on('fsearch:reset', reset);
    }

    $(this).keyup(function(e) {
        if (typeof _this.settings.keyupCallback == 'function') _this.settings.keyupCallback();

        var key = $(this).val();

        if (key.length >= _this.settings.length) {
            search(key);
        } else {
            reset();
        }
    });

    return this;
}

/**
 * @public
 * @function buildPostParam
 * @param {node} el An input node to be converted into a post string parameter
 * @param {string} val An optional value to be set for the passed in node.
 *                     Helpful when dealing with chosen selected fields.
 * @description Given a node, return an encoded url parameter.
 */
function buildPostParam( el, val ) {
    var value = val != undefined ? val : el.value;
    return '&' + encodeURIComponent(el.name) + '=' + encodeURIComponent( value ? value : '' );
}

function buildPostString(form, exclude, includeHidden) {
    var post = '';
    if (typeof(exclude) == 'undefined') exclude = [];
    if (typeof(exclude) == "string") exclude = [exclude];
    if (typeof(includeHidden) == 'undefined') includeHidden = true;

    var inputs = (includeHidden) ? $('input', form) : $('input:visible', form);

    inputs.each(function() {
        if ($.inArray($(this).attr('name'), exclude) == -1) {
            if (this.type == 'checkbox') {
                if (this.checked) post += "&" + this.name + "=" + encodeURIComponent($(this).val_or_empty());
            } else {
                if (this.type == 'radio') {
                    if (this.checked) {
                        post += "&" + this.name + "=" + encodeURIComponent($(this).val_or_empty());
                    }
                } else {
                    post += "&" + this.name + "=" + encodeURIComponent($(this).val_or_empty());
                }
            }
        }
    });

    var selects = (includeHidden) ? $('select', form) : $('select:visible', form);

    selects.each(function() {
        if ($.inArray(this.name, exclude) == -1) {
            post += "&" + this.name + "=" + encodeURIComponent($(this).val_or_empty());
        }
    });

    var textarea = (includeHidden) ? $('textarea', form) : $('textarea:visible', form);

    textarea.each(function() {
         if ($.inArray($(this).attr('name'), exclude) == -1) {
            post += "&" + this.name + "=" + encodeURIComponent($(this).val_or_empty());
        }
    });

    return post;
}


/* URL function
 * Get URL strings for use in Javascript and AJAX, based of the Twig url function
 * @param string view The view to get a URL for
 * @param string type The context for URL usage: "control" or "p2p"
 * @param array params The array of ID's to use
 */

var url = function(view, params){
    if ( typeof mappings !== "undefined" && typeof mappings[view] != 'undefined'){
        // setup some defaults
        var urlBase = '',
            params = params || [],
            urlString = '';

        // finds the correct url from the global mappings variable
        urlString = mappings[view].path;

        // find question marks and add commas to split on
        urlString = urlString.replace(/\?/gi, ',?,');

        // split up the string into array based on the "," character
        var urlParts = urlString.split(','),
        partsLength = urlParts.length,
        paramIndex = 0;

        // if the array item equals "?", replace it with the next item in the params array
        for( var i = 0; i < partsLength; i++ ){
            if ( urlParts[i] == '?' ){
                urlBase += params[paramIndex];
                paramIndex += 1;
            } else {
                urlBase += urlParts[i];
            }
        }

        return urlBase;
    }
};

/**
 * for testing if a number/string has a decimal value
 *
 * @param {string|number} value number to test
 * @returns {boolean} has decimal value
 */
function hasDecimalValue(value) {
    if (!value) return false;

    // convert to string
    if (typeof value === "number") {
        value = value.toFixed(2);
    }

    const hasDecimal = value.includes(".");
    if (!hasDecimal) return false;

    const hasZeroDecimal = value.endsWith(".00");

    return !hasZeroDecimal;
}

/** formatFormCurrency function
 * Format currency based on form settings
 *
 * @param {string} value The value to convert
 * @param {Boolean} trimZeroDecimal should trim zero value decimals
 * @returns {string} formatted currency string
 */
function formatFormCurrency(value = 0.00, trimZeroDecimal = false) {
    let symbol = "$";
    let location = 0;
    let format = 0;
    let decimals = 2;

    if (typeof QGIV?.Form?.currency !== "undefined") {
        symbol = QGIV.Form.currency.symbol;
        location = QGIV.Form.currency.symbolLocation;
        format = QGIV.Form.currency.format;
    }

    if (trimZeroDecimal) {
        const hasDecimals = hasDecimalValue(value);
        if (!hasDecimals) {
            decimals = 0;
        }
    }

    const formattedValue = currencyFormat(value, format, decimals);

    if (location) {
        return formattedValue + symbol;
    }

    return symbol + formattedValue;
};

function getCurrencyCharacters(format){
    var decimalCharacter = '';
    var thousandSeparator = '';

    switch(format)
    {
        case '1':
        case 1:
            // GERMAN_STANDARD
            decimalCharacter = ',';
            thousandSeparator = '.';
            break;
        case '2':
        case 2:
            // SWISS_STANDARD
            decimalCharacter = ',';
            thousandSeparator = "'";
            break;
        case '3':
        case 3:
            // FRENCH_STANDARD
            decimalCharacter = ',';
            thousandSeparator = ' ';
             break;
        default:
            // US_STANDARD
            decimalCharacter = '.';
            thousandSeparator = ',';
    }

    var characters = {
        dec : decimalCharacter,
        sep : thousandSeparator,
        group : format == 4 ? '2' : '3'
    }

    return characters;
}

/* currencyFormat function
 * Format currency for various international standards
 * @param string value The value to convert
 * @param string format The format to adapt the value to
 * @param int decimals The number of decimal places to use
 */
function currencyFormat(value, format, decimals) {
    var characters = getCurrencyCharacters(format),
        decimalSpaces = typeof decimals !== 'undefined' ? decimals : 2;

    // INDIAN_STANDARD
    if (format == 4) {
         value += '';
         x = value.split('.');
         x1 = x[0];
         x2 = x.length > 1 ? '.' + x[1] : '';

         var rgx = /(\d+)(\d{3})/;
         var z = 0;
         var len = String(x1).length;
         var num = parseInt((len/2)-1);

          while (rgx.test(x1)){

            if(z > 0) {
              x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            else {
              x1 = x1.replace(rgx, '$1' + ',' + '$2');
              rgx = /(\d+)(\d{2})/;
            }

            z++;
            num--;

            if(num == 0) {
              break;
            }
          }
         return x1 + x2;
    }

    if (isNaN(value)) value = '0.0';

    return number_format(value, decimalSpaces, characters.dec, characters.sep);
}

/*
 * Equivalent to number_format in PHP
 */
function number_format( number, decimals, dec_point, thousands_sep ) {
    var n = number, c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals;
    var d = dec_point;
    var t = thousands_sep, s = n < 0 ? "-" : "";
    var i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = (j = i.length) > 3 ? j % 3 : 0;

    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

function AutoNumericNumber( selector, options, reset ){
    var selector = selector || '.js-autonumeric',
        domElement = document.getElementById(selector.replace('#','')),
        defaultOptions = { modifyValueOnWheel: false },
        options = options || {},
        optionsSize = Object.keys(options).length,
        reset = reset || false;

    // AutoNumeric is not supported in Safari 9
    // I hate that we have to do this.
    if ( !!navigator.userAgent.match(/Version\/9+.*Safari/) ) {
        return;
    }

    // make sure we have a valid selector first
    if ( $(selector).length && typeof AutoNumeric !== 'undefined' ) {
        // based on additional classes, determine the options to use
        if ( optionsSize < 1 && $(selector).hasClass('decimal-percentage-format') ) {
            options = {
                digitGroupSeparator: '',
                maximumValue: 100,
                minimumValue: 0
            };
        } else if ( optionsSize < 1 && $(selector).hasClass('percentage-format') ) {
            options = {
                digitGroupSeparator: '',
                decimalPlaces: 0,
                maximumValue: 100,
                minimumValue: 0
            };
        } else if ( optionsSize < 1 && $(selector).hasClass('currency-input') ) {
            options = {
                minimumValue: 0,
                watchExternalChanges: true,
            };
        } else if ( optionsSize < 1 && $(selector).hasClass('numeric-format') ) {
            options = {
                digitGroupSeparator: '',
                decimalPlaces: 0,
                maximumValue: 9999999,
                minimumValue: 0
            };
        } else if ( optionsSize < 1 ) {
            options = AutoNumeric.getDefaultConfig();
        }

        //merge custom options with defaults
        options = $.extend({}, defaultOptions, options);

        // ensure that an element isnt initialized twice
        if ( !AutoNumeric.isManagedByAutoNumeric(domElement) ) {
            // init the plugin for single or multiple instances
            if ( selector.indexOf(',') > -1 ) {
                new AutoNumeric.multiple(selector, options);
            }
            else {
                new AutoNumeric(selector, options);
            }
        } else {
            AutoNumeric.getAutoNumericElement(domElement).global.update(options);
        }
    }
}

/**
 * @function getQMaskConfigs
 * @description Returns default QMask configurations.
 * @param {string} maskType Type of mask to init. Determines which config is returned.
 * @returns {object} IMask configuration object
 */
function getQMaskConfigs ( maskType ) {
    var QMaskConfigs =  {
        alphaNumericReplaceSpaces : {
            inputMode: 'text',
            mask : function ( val ) {
                return /^[a-zA-Z0-9_ ]*$/.test( val );
            },
            prepare : function ( str ) {
                return str.split( ' ' ).join( '_' );
            }
        },

        currency : {
            inputMode: 'decimal',
            mask : '$num',
            blocks : {
                // E.g. "$9,876,543.21"
                num : {
                    mask : Number,
                    signed : false,  // disallow negative
                    thousandsSeparator : ',',
                    normalizeZeros : true,  // appends or removes zeros at ends
                    padFractionalZeros : true,  // adds zeros at end to the length of scale
                    radix : '.'  // fractional delimiter
                }
            }
        },

        date : {
            inputMode: 'text',
            mask : function ( val ) {
                var dateArr = val.split(/[\D]/);
                var month = parseInt(dateArr[0]);
                var day =
                    typeof dateArr[1] === 'undefined' || dateArr[1] === ''
                        ? 0
                        : parseInt(dateArr[1]);
                var year =
                    typeof dateArr[2] === 'undefined' || dateArr[2] === ''
                        ? 0
                        : parseInt(dateArr[2]);

                var validMonth =
                    month >= (dateArr.length > 1 ? 1 : 0) && // month is ≥ 1 unless entering a leading 0
                    month <= 12 &&
                    dateArr[0].length <= 2 &&
                    dateArr[0] !== '00';
                var validDay =
                    dateArr.length < 2
                        ? true // day is irrelevant until '/' is entered
                        : day >= (dateArr.length > 2 ? 1 : 0) && // day is ≥ 1 unless entering a leading 0
                          day <= 31 &&
                          dateArr[1].length <= 2 &&
                          dateArr[1] !== '00';
                var validYear =
                    dateArr.length < 3
                        ? true // year is irrelevant unitl a second '/' is entered
                        : year < 3000 &&
                          dateArr[2].length <= 4 &&
                          dateArr[2] !== '000';

                return dateArr.length <= 3 && validMonth && validDay && validYear;
            },
            // making sure we have only the correct character types
            prepare : function ( val ) {
                return val.split( /[\D]/ ).join( '/' );
            },
            // attempt to format as mm/dd/yyyy
            commit : function ( date ) {
                var dateArr = date.split( '/' );
                var month = dateArr[ 0 ];
                var day = dateArr[ 1 ];
                var year = dateArr[ 2 ];

                if ( dateArr.length !== 3 ) return;

                if ( day.length === 1 ) day = '0' + day;
                if ( month.length === 1 ) month = '0' + month;
                if ( year.length === 2 && year < 100 && year >= 30 ) year = '19' + year;
                if ( year.length === 2 && year < 30 ) year = '20' + year;

                if ( month.length && day.length && year.length ) {
                    this._value = [ month, day, year ].join( '/' )
                };
            }
        },

        credit: {
            inputMode: 'numeric',
            mask: '0000000000000000000'
        },

        tel: {
            inputMode: 'tel',
            mask: '(000) 000-0000'
        },

        zip: {
            inputMode: 'numeric',
            mask: '00000'
        },

        percent: {
            inputMode: 'decimal',
            mask: 'num%',
            lazy: false,
            blocks: {
                num: {
                    mask: Number,
                    thousandsSeparator: ','
                }
            }
        }
    };

    return QMaskConfigs[ maskType ];
};

/**
 * @function initQMask
 * @description Inits inputs as IMask with specified mask type
 * @param {jQuery|HTMLElement} $inputs Elements to be masked
 * @param {string} [type] Type of mask. Must match a key in the `IMask` object returned by getQMaskConfigs function in system.interface.js.
 *                        If not passed in, this function will look for `data-mask-type` on the input element.
 */
function initQMask ( $inputs, type ) {
    QGIV.QMasks = QGIV.QMasks || {};

    $( $inputs ).each( function () {
        var $input = $( this );
        var inputID = $input.prop( 'id' );
        var _type = $input.attr('data-mask-type') || type;
        var config = getQMaskConfigs( _type );

        // We need to re-instantiate for new events
        if(!$input.attr("data-is-standard-event")) {
            // if not new event prevent input from being reinitiated
            if ( typeof QGIV.QMasks[ inputID ] !== 'undefined' ) return;
        }

        // throw error for invalid type
        if ( typeof config === 'undefined' ) return console.error( 'Invalid QMask type' );

        // make sure element exists. Added escape selector to handle ID's in new standard event containing []'s
        if ( $input.length === 0 || $( '#' + $.escapeSelector(inputID) ).length === 0 ) return console.error( 'Failed to init QMask.' );

        // add inputmode for mobile
        $input.prop( 'inputmode', config.inputMode )

        QGIV.QMasks[ inputID ] = IMask(
            $input[ 0 ],
            config
        );
    } );
};

/**
 * @function destroyQMask
 * @description Destroys IMask
 * @param {jQuery|HTMLElement} $inputs Elements to be unmasked
 */
function destroyQMask ( $inputs ) {
    $( $inputs ).each( function () {
        var $input = $( this );
        var inputID = $input?.prop( 'id' );
        // destroy IMask
        QGIV.QMasks[ inputID ]?.destroy();
        delete QGIV.QMasks[ inputID ];

        // remove added prop
        $input.removeProp( 'inputmode' );
    } );
};

/**
 * @function initNumericQMask
 * @description Inits inputs as numeric IMask and adds +/- buttons to number input
 * @param {jQuery|HTMLElement} $inputs Elements to be masked
 */
function initNumericQMask ( $inputs ) {
    QGIV.QMasks = QGIV.QMasks || {};

    $( $inputs ).each( function () {
        var $input = $( this );
        var disabled = $input.prop( 'disabled' ) || $input.prop( 'readonly' );
        var props = {
            mask : Number,
            min : 0,
            max : Number.MAX_SAFE_INTEGER,
            step : 1,
            thousandsSeparator : ','
        };

        // grab the input's attributes and store them in `props`
        $.each( $input[ 0 ].attributes, function () {
            props[ this.name ] = ( isNaN( this.value ) || this.name === 'value' ) ? this.value : parseInt( this.value )
        } );

        // We need to re-instantiate for new events
        if(!$input.attr("data-is-standard-event")) {
            // if not new event prevent input from being reinitiated
            if ( typeof QGIV.QMasks[ props.id ] !== 'undefined' ) return;
        }
        // passing `value` here causes errors so we have to remove it from `props`
        delete props.value;
        QGIV.QMasks[ props.id ] = IMask( $input[ 0 ], props );

        // make sure there's something in the input (placeholder or value)
        if ( $input.val() === '' && ( typeof props.placeholder === 'undefined' || props.placeholder.length === 0 ) ) {
            QGIV.QMasks[ props.id ].value = props.min + '';
        }

        // add the +/- buttons
        if ( $input.closest( '.numeric-text-wrap' ).length == 0 ) {
            $input.wrap( '<div class="numeric-text-wrap"></div>' )
                .after(
                    '<span' + ( disabled ? ' class="appearance-disabled"' : '' ) + '>' +
                        '<a class="ui-icon numeric-control increment" href="#" tabindex="-1">' + props[ 'data-increment-icon' ] + '</a>' +
                        '<a class="ui-icon numeric-control decrement" href="#" tabindex="-1">' + props[ 'data-decrement-icon' ] + '</a>' +
                    '</span>'
                );
        }

        $input.closest( '.numeric-text-wrap' ).on( 'click', '.numeric-control', function ( e ) {
            var $button = $( this );
            var prevVal = parseFloat( QGIV.QMasks[ props.id ].unmaskedValue ) || props.min;
            var canIncrement = ! ( ( prevVal + props.step ) > props.max );
            var canDecrement = ! ( ( prevVal - props.step ) < props.min );

            e.preventDefault();

            if ( ! disabled ) {
                if ( $button.hasClass( 'increment' ) && canIncrement ) {
                    QGIV.QMasks[ props.id ].value = prevVal + props.step + '';
                    $( '#' + props.id ).trigger( 'change' );
                } else if ( $button.hasClass( 'decrement' ) && canDecrement ) {
                    QGIV.QMasks[ props.id ].value = prevVal - props.step + '';
                    $( '#' + props.id ).trigger( 'change' );
                }
            }
        } );

        // bind unlimited functionality
        $input.closest( '.field-with-button-container' ).on( 'change', '.ui-numeric-toggle-unlimited', function () {
            var $container = $( this ).closest( '.field-with-button-container' );

            // Check explicitly to account for UI.clearFields
            if ( $(this).prop( 'checked' ) ) {
                $container.addClass( 'active unlimited' );
            } else {
                $container.removeClass( 'active unlimited' );
            }
        } );
    } );
};

/**
 * @function destroyNumericQMask
 * @description Destroys IMask
 * @param {jQuery|HTMLElement} $inputs Elements to be unmasked
 */
function destroyNumericQMask ( $inputs ) {
    $( $inputs ).each( function () {
        var $input = $( this );
        var inputID = $input.prop( 'id' );

        // remove event listeners
        $input.closest( '.field-with-button-container .ui-numeric-toggle-unlimited' ).off( 'change' );

        // remove added elements
        if ($input.closest('.numeric-text-wrap').length !== 0) {
            $input.siblings( 'span' ).remove();
            $input.unwrap();
        }
        // destroy IMask
        QGIV.QMasks[ inputID ]?.destroy();
        delete QGIV.QMasks[ inputID ]
    } );
};

/*
 * Embed event triggers
 */
var Embed = {
    resize : function(){
        $(document).trigger('embed:resize');
    },
    top: function(){
        $(document).trigger('embed:top');
    }
};


/*
 * Qgiv Utilities Library
 */
QGIV.Utilities = {
    toFloat : function(string, decimal){
        var string = string || '',
            decimal = decimal || 2;

        if ( typeof string == 'string' ){
            string = string.replace(/\,/g, '');
        }

        string = parseFloat(string);
        string = parseFloat(string.toFixed(decimal));

        return string;
    },

    numberWithCommas : function(x){
        return x.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
    },

    randomNumber : function(length){
        var length = length || 10,
            number = '';

        for ( var i = 0; i < length; i++ ) {
            number += Math.floor(Math.random() * 10);
        }

        return number;
    },

    startsWithVowel : function(string) {
        var string = string || '';

        return !! string.charAt(0).toLowerCase().match(/[aeiou]/);
    },

    parseJSON : function(data) {
        var data = data || '',
            parsedData;

        try {
            parsedData = JSON.parse(data);
        } catch (e) {
            parsedData = null;
        }

        return parsedData;
    },

    throttle: function (func, limit) {
        var lastFunc;
        var lastRan;

        return function () {
            var context = this;
            var args = arguments;

            if (!lastRan) {
                func.apply(context, args);
                lastRan = Date.now();

            } else {
                clearTimeout(lastFunc);
                lastFunc = setTimeout(function () {
                    func.apply(context, args);
                    lastRan = Date.now();

                }, limit - (Date.now() - lastRan));
            }
        }
    },

    debounce: function(func, delay) {
        var lastFunc = null;

        return function() {
            var context = this;
            var args = arguments;

            if(lastFunc) {
                clearTimeout(lastFunc);
            }

            lastFunc = setTimeout(function(){
                func.apply(context, args);
            }, delay);
        }
    },
    /**
     * for getting param values from URL
     * @returns {Object} Keyed object
     */
    getSearchKeyValuePair: () => {
        if (!window.location.search) return null;
        const search = window.location.search.replace("?", "");
        const searchObject = {};
        search.split("&").forEach((item) => {
            const [key, value] = item.split("=");
            searchObject[key] = decodeURIComponent(value);
        });
        return searchObject;
    },
    /**
     * for removing a querystring
     * @param {Boolean} pushState Use pushState instead of replaceState.
     */
    removeQuerystring: (pushState = false) => {
        if (!window.location.search) return;

        const { getSearchKeyValuePair } = QGIV.Utilities;

        const ignoredParams = ["utm_", "gclid"]; // re-marketing params

        // remove the query string from the address bar, except ignored params
        const searchValues = getSearchKeyValuePair();
        const filteredParams = Object.entries(searchValues)
            .filter(([key]) =>
                ignoredParams.some((ip) => key.toLowerCase().startsWith(ip)),
            )
            .map(([key, value]) => `${key}=${value}`)
            .join("&");

        const url = `${window.location.pathname}?${filteredParams}`;

        // if forcing a pushState instead of a replaceState
        if (pushState) {
            window.history.pushState(null, document.title, url);
            return;
        }

        window.history.replaceState({}, document.title, url);
    },
};

/**
 * @function downloadBlob
 * @description Trigger a download dialog to open in the onload callback of an
 *      XMLHttpRequest
 * @param {XMLHttpRequest} xhr Request sent to retrieve file for download
 */
function downloadBlob(xhr) {
    var isIE = window.navigator && window.navigator.msSaveOrOpenBlob;
    var filename = xhr
        .getResponseHeader('content-disposition')
        .split('filename=')[1]
        .split('"')
        .join('');
    var e = document.createElement('a');
    var blobUrl = window.URL.createObjectURL(xhr.response);

    if (isIE) {
        // for IE
        window.navigator.msSaveOrOpenBlob(xhr.response, filename);
        return;
    }

    e.href = blobUrl;
    e.download = filename;
    document.body.appendChild(e);
    e.click();
    document.body.removeChild(e);
}

/**
 * @public
 * @function getEnums
 * @description Get request to retrieve Enums from BE
 * @returns {jQuery.jqXHR} Used to chain callback methods
 */
const getEnums = () => $.fn.qpost({
    url: "/views/api/internal/api_enums.php",
    type: "GET",
}).then(
    // decode base-64 encoded string of Enums and return it
    (data) => JSON.parse(window.atob(data))
).fail(() => {
    // uh oh! post an error
    Message.post(
        "Could not get Enums. Please refresh the page to try again.",
        "error",
    );
});
